import "@/App.css";
import "@/site.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";
import { SiteLayout } from "./components/site/SiteLayout";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import Shows from "./pages/Shows";
import ShowPage from "./pages/ShowPage";
import MerchPage from "./pages/MerchPage";
import GalleryPage from "./pages/GalleryPage";
import { BookingPage, FeaturePage, StudioBookingPage } from "./pages/RequestPages";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage";
import { PaymentCancel, PaymentSuccess } from "./pages/PaymentPages";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route element={<SiteLayout />}>
                <Route path="/home" element={<Home />} />
                <Route path="/shows" element={<Shows />} />
                <Route path="/shows/:id" element={<ShowPage />} />
                <Route path="/merch" element={<MerchPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/feature" element={<FeaturePage />} />
                <Route path="/studio" element={<StudioBookingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<Navigate to="/home" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
